import { mutatorAction } from 'satcheljs';
import { inlineFeedbackDialogStore } from '../store/store';

export let setInlineFeedbackResponseCategories = mutatorAction(
    'setInlineFeedbackResponseCategories',
    (inlineFeedbackCategory: string, checked: boolean) => {
        let store = inlineFeedbackDialogStore();
        if (checked && !store.inlineFeedbackResponseCategories.includes(inlineFeedbackCategory)) {
            store.inlineFeedbackResponseCategories.push(inlineFeedbackCategory);
        }
        if (!checked && store.inlineFeedbackResponseCategories.includes(inlineFeedbackCategory)) {
            store.inlineFeedbackResponseCategories.splice(
                store.inlineFeedbackResponseCategories.indexOf(inlineFeedbackCategory),
                1
            );
        }
    }
);
